var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.block.hidden)?_c('div',{staticClass:"preview-block-editor",attrs:{"id":_vm.containerId}},[_c('BlockEditor',{attrs:{"component-data":_vm.componentData,"type":_vm.block.type,"preview":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }